import React, {Component} from 'react'
import {authenticationService} from '../../../services/AuthenticationService';

import SvGraphics from "../../../assets/SvGraphics";
import {history} from "../../../utils/history";
import * as Yup from "yup";
import validationHelper from "../../../utils/validationHelper";
import utils from "../../../utils/utils";
import Error from "../../../components/single_components/Error";
import Constants from "../../../utils/constants";
import Config from "../../../config/Config";
import {compose} from "redux";
import {withTranslation} from "react-i18next";
import AlertConfirm from "../../../components/modals/Confirm";
import ReCaptcha from "../ReCaptcha";
import LeumitLogo from "../../../assets/LeumitLogo.png"
import {appendIchilovQuery, hasIchilovQuery} from "../../../utils/routeUtils";
import ichilovImg from "../../../assets/Soraski.svg";

class LoginLeumitRegComposed extends Component {
    constructor(props) {
        super(props);

        if (authenticationService.currentUserValue) {
            this.props.history.push(appendIchilovQuery('/dashboard'));
        }
        this.recaptchaRef = React.createRef()

        this.state = {
            username: '',
            password: '',
            auth: {},
            isErr: false,
            errMessage: '',
            errors: {},
            detailsSeen: false,
            errorsOnSave: {},
        }
    }

    initValidation = async () => {
        let {t} = this.props
        let validationSchema = Yup.object().shape({
            username: Yup.string().min(6, t('defaults.login.username_empty_inv')).matches(Constants.emailRegExp, t('defaults.login.username_inv')).required(t('defaults.login.username_req')),
            password: Yup.string().required(t('defaults.login.pwd_req')),
            //.matches(Config.passwordRegExp,'Password must contain at least one of: a-z, A-z, 0-9 and (!,@,#,$,%,^,*,) with length of 8-20')
        })
        let errors = await validationHelper.validate(this.state.auth, validationSchema)
        await this.setState({
            validationSchema,
            errors
        })
    }

    async componentWillMount() {
        await this.initValidation()
    }

    async componentDidMount() {

        let {t} = this.props
        if (!this.state.detailsSeen) {
            let confirm = await AlertConfirm({
                options: {
                    title: t('hcpLeumitPatientRequests.userCreated'),
                    cancelLabel: 'none',
                    proceedLabel: 'OK'
                }
            }, t('hcpLeumitPatientRequests.passSent'))
            if (confirm) {
                this.setState({detailsSeen: true})
            }
        }
    }


    onSubmit = async () => {
        let isLocal = process.env.REACT_APP_ENV === 'localhost'

        if (!isLocal) {
            await this.recaptchaRef.reset()
            await this.recaptchaRef.execute()
        } else {
            await this.submitData("NOTOKENINLOCAL");
        }

    }

    submitData = async (reCaptchaToken) => {
        let {t} = this.props
        if (!utils.isEmpty(this.state.errors)) {
            this.setState({errorsOnSave: this.state.errors});
            return;
        }
        let {username, password} = this.state
        let response = await authenticationService.login(username, password, reCaptchaToken);

        if (response.status < 400) {
            let data = response.data

            if (data.profile.Leumit_clinic !== "T" && (data.role[0] === "Patient" || data.role[0] === "Doctor")) {
                await this.setUserName({target: {value: ''}})
                await this.setPassword({target: {value: ''}})
                this.setState({
                    isErr: true,
                    errMessage: response.data && response.data.message ? response.data.message : t('defaults.login.usernameError'),
                })
                await authenticationService.logout()

            } else {
                if (data && data.hasOwnProperty('status') && String(data['status']).toLowerCase() === 'pass') {
                    if (data.hasOwnProperty('updatePassword') && data['updatePassword'] === true) {
                        const {from} = {from: {pathname: appendIchilovQuery("/pain_create_password")}};
                        this.props.history.push(from);
                    } else if (data.hasOwnProperty('updatePassword') && data['updatePassword'] === false) {
                        if (data['role'][0] === "Patient") {
                            let patientInfo = data
                            history.push({
                                pathname: appendIchilovQuery(`/pain_patient_self_onboard`),
                                state: {
                                    patientInfo,
                                    from: {
                                        fromPath: `/pain_patient_self_onboard`,
                                    }
                                },
                            })
                        } else {
                            const {from} = {from: {pathname: appendIchilovQuery("/pain_requests_dashboard")}};
                            this.props.history.push(from);
                        }
                    }
                } else if (data && data.hasOwnProperty('status') && String(data['status']).toLowerCase() === '2fa') {
                    const {from} = {from: {pathname: appendIchilovQuery("/pain_2FA")}};
                    this.props.history.push(from);
                } else {
                    await this.setUserName({target: {value: ''}})
                    await this.setPassword({target: {value: ''}})
                    this.setState({
                        isErr: true,
                        errMessage: response.data && response.data.message ? response.data.message : t('defaults.login.connectionError'),
                    })
                }
            }

            // utils.set(data,'status','pass')
            // utils.set(data,'updatePassword',true)

        } else {
            await this.setUserName({target: {value: ''}})
            await this.setPassword({target: {value: ''}})
            this.setState({
                isErr: true,
                errMessage: response.data && response.data.message ? response.data.message : t('defaults.login.connectionError'),
            })
        }
    }

    setUserName = async (e) => {
        let {auth, validationSchema} = this.state
        this.setState({username: e.target.value.trim()})
        utils.set(auth, 'username', e.target.value.trim())
        let errors = await validationHelper.validate(auth, validationSchema);
        let errorsOnSave = this.state.errorsOnSave;
        if (utils.get(errorsOnSave, 'username')) {
            utils.set(errorsOnSave, 'username', utils.get(errors, 'username'))
        }
        this.setState({
            auth,
            errors,
            errorsOnSave,
            isErr: false, errMessage: ''
        })
    }

    setPassword = async (e) => {
        let {auth, validationSchema} = this.state
        this.setState({password: e.target.value.trim()})
        utils.set(auth, 'password', e.target.value.trim())
        let errors = await validationHelper.validate(auth, validationSchema);
        let errorsOnSave = this.state.errorsOnSave;
        if (utils.get(errorsOnSave, 'password')) {
            utils.set(errorsOnSave, 'password', utils.get(errors, 'password'))
        }
        this.setState({
            auth,
            errors,
            errorsOnSave,
            isErr: false, errMessage: ''
        })
    }

    resetPassword = () => {
        history.push({
            pathname: appendIchilovQuery('/pain_reset_password'),
            state: {
                Email: this.state.username,
                from: {
                    fromPath: `/login_pain`,
                }
            },
        })
    }

    render() {
        let {t} = this.props
        return (
            <div className={"login-page-Leumit"}>
                <div className={'sade-Pain-login-logo-container'}>
                    <SvGraphics svgname={'painClinicLogo'} className={'sade-Pain-login-logo'}/>
                    {hasIchilovQuery() ? <img src={ichilovImg} className={'sade-Pain-login-logo'} alt={""}/> :
                        <img src={LeumitLogo} className={'sade-Pain-login-logo'} alt={""}/>
                    }
                </div>
                <div className={'centered sade-login-main-board'}>
                    <label className={'sade-login-label'}>{t('defaults.login.login')}</label>
                    <div className={'sade-login-form-container'}>
                        <div className={'h-centered sade-login-form'}>
                            <Error isNonFloat={true} errorMessage={utils.get(this.state.errorsOnSave, 'username')}
                                   isShown={!!utils.get(this.state.errorsOnSave, 'username')}/>
                            <div className={"login-input-wrapper form-group sade-login-form-group"}>
                                <input className={"sade-input sade-form-input sade-login-input-field"}
                                       placeholder={t('defaults.login.username')}
                                       type={"text"}
                                       name={"Username"}
                                       id={"search"}
                                       value={this.state.username}
                                       onChange={e => this.setUserName(e)}
                                       onKeyPress={event => {
                                           if (event.key === 'Enter') {
                                               this.onSubmit()
                                           }
                                       }}/>
                                <SvGraphics className={"input-pic"} svgname={'person'}
                                            style={{width: '20px', height: '20px'}}/>
                            </div>
                            <Error isNonFloat={true} errorMessage={utils.get(this.state.errorsOnSave, 'password')}
                                   isShown={!!utils.get(this.state.errorsOnSave, 'password')}/>
                            <div className={"login-input-wrapper form-group sade-login-form-group"}>
                                <input className={"sade-input sade-form-input sade-login-input-field"}
                                       placeholder={t('defaults.login.pwd')}
                                       type={"password"}
                                       name={""}
                                       value={this.state.password}
                                       onChange={e => this.setPassword(e)}
                                       onKeyPress={event => {
                                           if (event.key === 'Enter') {
                                               this.onSubmit()
                                           }
                                       }}/>
                                <SvGraphics className={"input-pic"} svgname={'pass1'}
                                            style={{width: '20px', height: '20px'}}/>
                            </div>
                            <div className="form-group sade-login-form-group">
                                <button className="btn h-centered btn-primary sade-login-form-button"
                                        onClick={this.onSubmit}>{t('defaults.login.login')}</button>
                            </div>

                        </div>
                    </div>
                    <div className={'sade-login-form-group loginError red h-centered'}>
                        <Error isNonFloat={true}
                               errorMessage={t('defaults.login.auth_err') + ': ' + this.state.errMessage}
                               isShown={this.state.isErr}/>
                    </div>
                    <div className={'h-centered sade-login-footer-container'} onClick={this.resetPassword.bind(this)}>
                        <a>{t('defaults.login.forgot_pwd')}?</a>
                    </div>
                    <div className={'h-centered sade-login-footer-container sade-register'} onClick={() => {
                        history.push({
                            pathname: '/register_pain',
                            state: {
                                Email: this.state.username,
                                from: {
                                    fromPath: `/login_pain`,
                                }
                            },
                        })
                    }}>
                        <a>{t('defaults.login.Register')}</a>
                    </div>
                </div>
                {/*  <div className={'h-centered sade-asaya-login-logo-container'}>
                    <SvGraphics svgname={'sade_logo'} className={'sade-login-logo'} style={{width:'183px'}}/>
                </div>*/}

                <div className={'sade-Pain-bottom-container2'}>
                    <div className="need-help-label">
                        {t('defaults.Registration.need_help')}
                    </div>

                    <div className="need-help-block">

                        <div className="need-help-block-content">
                            <SvGraphics svgname={'global'} className={"login-website-icon"}/>

                            <div className={"login-website-div"}>
                                <a className={"login-website-label"} target={"_blank"}
                                   href={'https://www.sade.group/he/pain'}>www.sade.group</a>
                            </div>

                        </div>
                        <div className="need-help-block-content">
                            <SvGraphics svgname={'email-icon'} className={"login-website-icon"}/>

                            <div className={"login-website-div"}>

                                <a className={"login-website-label"}
                                   href="mailto: pain@sade.group">pain@sade.group</a>
                            </div>

                        </div>


                        <div className="need-help-block-content">
                            <SvGraphics svgname={'phone-icon'} className={"login-website-icon"}/>

                            <div className={"login-website-div"}>
                                <a className={"login-website-label"} href="tel:073-380-7972">073-380-7972</a>
                            </div>
                        </div>
                        <div className="need-help-block-content">
                            <SvGraphics svgname={'clock'} className={"login-website-icon"}/>

                            <div className={"login-website-div"}>

                                <a className={"login-website-label"}
                                   href="">{t('patient_self_boarding.workingHours')}</a>
                            </div>

                        </div>
                    </div>
                </div>


                <div className={'login-version-element'}>
                        <div className={'login-version-element-label'}>Version:</div>
                        <div className={'login-version-element-value'}>{Config.version} {Config.build}</div>
                    </div>
                <ReCaptcha setRef={ref => (this.recaptchaRef = ref)}
                           action={async (reCaptchaToken) => {
                               await this.submitData(reCaptchaToken);
                           }}
                    /*setErr={ this.setRecapchaErrors()}*//>
            </div>

        )
    }
}

let LoginPainReg = compose(
    withTranslation()
)(LoginLeumitRegComposed)
export default LoginPainReg;
